export default __webpack_public_path__ + "static/media/DSC_7658.3b732d66.jpg";